import React from "react";
import { default as MUITooltip } from "@mui/material/Tooltip";
import styled from "styled-components";

const StyledMUITooltip = styled(MUITooltip)``;

export const Tooltip = ({ id, title, placement, children }) => (
  <StyledMUITooltip {...{ id, title, placement }}>{children}</StyledMUITooltip>
);
